<script>
    import { createEventDispatcher } from 'svelte';
    import { Link, navigateTo } from 'yrv';
    import ActionButton from '../../components/ActionButton/ActionButton.svelte'
    import Dialog from '../../components/Modal/Dialog.svelte'

    export let item

    let deleteDialog = false


    const dispatch = createEventDispatcher ();

    const openItem = (event) => {
        event.stopPropagation ();
        navigateTo ('/app/clients/' + item.id + '/logs')
    }

    const editItem = (event) => {
        event.stopPropagation ();
        navigateTo ('/app/clients/' + item.id + '/details')
    }

    const deleteItem = event => {
        event.stopPropagation ();
        deleteDialog = true
    }

    const cancelDelete = event => {
        deleteDialog = false
    }

    const confirmDelete = event => {
        deleteDialog = false
        dispatch ('delete', item)
    }
</script>

<style>
    .ClientItem {
        padding: 0;
        border-radius: 5px;
        width: 380px;
        font-size: 14px;
        margin-bottom: 5px;
        background-color: var(--forge-primary-bg);
        position: relative;
    }
    .ClientItem .icon {
        float: left;
        width: 60px;
        height: 60px;
        overflow: hidden;
        text-align: center;
        line-height: 60px;
        font-size: 20px;
    }
    .ClientItem .meta {
        float: left;
        width: calc(100% - 60px);
        padding: 10px 15px 10px 0;
    }
    .ClientItem .icon .image-holder {
        display: inline-block;
        width: 42px;
        height: 42px;
        border-radius: 50%;
        margin-top: 10px;
        vertical-align: top;
    }
    .ClientItem .icon img {
        width: 100%;
        border-radius: 50%;
        vertical-align: top;
    }
    .ClientItem .lbl {
        font-weight: 600;
    }
    .ClientItem .txt {
        font-size: 12px;
        line-height: 14px;
        color: var(--text-secondary);
    }
    .ClientItem .hover {
        position: absolute;
        top: 0;
        right: 0;
        width: 100%;
        height: 100%;
        /* background-color: var(--forge-secondary-selected); */
        /* background-color: rgb(156, 184, 202, .6); */
        border-radius: 5px;
        display: none;
    }
    .ClientItem .hover .ctrls {
        position: absolute;
        width: 100%;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        padding: 0 10px;
        text-align: right;
    }
    .ClientItem:hover {
        background-color: var(--forge-secondary-selected);
    }
    .ClientItem:hover .hover {
        display: block;
    }
</style>

<div class="ClientItem clearfix" on:click={openItem}>
    <div class="icon">
        {#if item.image}
            <div class="image-holder">
                <img src={item.image} alt="Client avatar"/>
            </div>
        {:else}
            <i class="fad fa-users"></i>
        {/if}
    </div>
    <div class="meta">
        <div class="lbl">{item.name}</div>
        <div class="txt">{item.social_r}</div>
        <!-- <div class="txt">{item.phone || item.email || '-'}</div> -->
    </div>

    <div class="hover">
        <div class="ctrls">
            <ActionButton icon="far fa-arrow-right" on:click={openItem} />
            <ActionButton icon="far fa-pencil" on:click={editItem} />
            <ActionButton danger icon="far fa-trash" on:click={deleteItem} />
        </div>
    </div>
</div>

{#if deleteDialog}
    <Dialog 
        title="Vuoi davvero eliminare questo cliente?" 
        on:cancel={cancelDelete} 
        on:confirm={confirmDelete}
        leftAlign>
        <div class="dialog-meta">
            <div class="lbl">{item.name}</div>
            <!-- <div class="txt">{data.description}</div> -->
        </div>
    </Dialog>
{/if}